/**
 * Centralised backend URL resolver with custom-domain fallback.
 * Prevents CORS failures when the production bundle was built with a stale
 * REACT_APP_BACKEND_URL but is now served from a different custom domain.
 */
export function getBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === 'undefined') return envUrl || '';
  const host = window.location.hostname;
  const origin = window.location.origin;
  // Trust env var on localhost, Emergent preview subdomains, and Emergent host domains
  if (host === 'localhost' || host === '127.0.0.1') return envUrl || origin;
  if (host.endsWith('.emergentagent.com')) return envUrl || origin;
  if (host.endsWith('.emergent.host')) return envUrl || origin;
  // Custom production domains: always use same-origin to avoid CORS
  return origin;
}

export const API_URL = getBackendUrl();
